import * as R from 'ramda';
import * as Promise from 'bluebird';
import { of, from } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import {
  handleLoginFormLoginResponseError,
  handleLoginFormLoginResponse,
  handleLoginFormNeedsSync,
  types,
} from './loginForm.redux';
import { types as syncDeviceTypes } from 'components/syncDeviceModal/syncDeviceModal.redux';
import { api } from 'components/api';
import { decryptSession } from '../../utils';

const login = login_data =>
  new Promise((success, fail) => {
    console.log('Loging User');
    const { ajax } = api;
    const { username, password } = login_data;

    ajax(`user/login`, {
      type: 'POST',
      data: {
        username,
        password,
      },
    })
      .then(access_data => success({ access_data, login_data }))
      .catch(fail);
  });

const subscribeDevice = ({ user_data, access_data, login_data }) =>
  new Promise((success, fail) => {
    console.log('Subscribe device');
    const { ajaxSession } = api;
    const DeviceUUID = require('device-uuid').DeviceUUID;

    const deviceUUID = new DeviceUUID();
    const deviceId = deviceUUID.get();
    const deviceInfo = deviceUUID.parse();
    const deviceLocalUserSession = decryptSession();

    const deviceInUserData = R.find(R.propEq('device_id', deviceId))(user_data.devices);
    console.log('device in user data', deviceInUserData);

    if (!deviceInUserData) {
      ajaxSession(`userDevice`, {
        type: 'POST',
        data: {
          userDevice: JSON.stringify({
            device_id: deviceId,
            device_info: JSON.parse(JSON.stringify(deviceInfo)),
            device_local_user_session: deviceLocalUserSession,
          }),
        },
      })
        .then(device_data =>
          success({
            needsSync: true,
            user_data,
            access_data,
            login_data,
            device_data: R.pick([
              'id',
              'created_at',
              'updated_at',
              'device_id',
              'device_info',
              'device_local_user_session',
            ])(device_data),
          })
        )
        .catch(fail);
    } else {
      success({
        user_data,
        access_data,
        login_data,
        device_data: deviceInUserData,
        needsSync: !deviceInUserData.device_synced,
      });
    }
  });

const getUser = ({ access_data, login_data }) =>
  new Promise((success, fail) => {
    console.log('Get logged User');
    const { ajaxSession, setAccessToken, setUserSessionUserData } = api;
    const { username, password } = login_data;
    setAccessToken({ access_token: access_data, autologinCredentials: { username, password }, checkOfflineOn: true });
    console.log('access_token set');

    ajaxSession(`user`, { type: 'GET' })
      .then(user_data => {
        // setupLocalSession({
        //   user_data,
        //   access_data,
        //   login_data,
        // });
        setUserSessionUserData(user_data);
        success({ access_data, login_data, user_data });
      })
      .catch(fail);
  });

const handleLoginFormLoginRequestEpic = action$ =>
  action$.pipe(
    ofType(types.handleLoginFormLoginRequest),
    mergeMap(({ payload }) => {
      const { username, rememberMe } = payload;
      const { setAccessToken } = api;
      setAccessToken({});
      console.log('calling login');

      return from(
        R.pipeP(
          login,
          getUser,
          userInfo => {
            if (userInfo.user_data.devices.length < 10) {
              return subscribeDevice(userInfo);
            } else {
              throw 'No more devices allowed';
            }
          }
        )(payload)
      ).pipe(
        map(({ user_data, access_data, login_data, device_data, needsSync }) => {
          return handleLoginFormLoginResponse({
            username,
            rememberMe,
            userData: user_data,
            accessData: access_data,
            loginData: login_data,
            deviceData: device_data,
            needsSync,
            logged: true,
            error: '',
          });
        }),
        catchError(error =>
          of(
            handleLoginFormLoginResponseError({
              username: '',
              userData: {},
              accessData: {},
              loginData: {},
              deviceData: {},
              needsSync: false,
              logged: false,
              error: error,
            })
          )
        )
      );
    })
  );

const handleLoginFormNeedsSyncEpic = action$ =>
  action$.pipe(
    ofType(syncDeviceTypes.syncLocalImagesSynced),
    mergeMap(() => {
      setTimeout(() => {
        location.reload();
      }, 500);

      return of(handleLoginFormNeedsSync({ needsSync: false }));
    })
  );

export default combineEpics(handleLoginFormLoginRequestEpic, handleLoginFormNeedsSyncEpic);
